<template>
  <div class="checkin">
      <div class="align-middle">
          <!--<h1 class="md-title">Aggiungi uno shop</h1>-->
          <span class="muted">Già prenotato?</span>
          <md-button @click="goTo" class="md-raised md-primary" md-align="center">Effettua il Check-in</md-button>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Checkin',
  data() {
    return {
    }
  },
  methods: {
    goTo(){
        this.$router.push({ name: 'checkin' })
    }
  },
  mounted() {
    
  }
}
</script>

<style lang="scss" scoped>
    .checkin {
        height: 95px;
    }
</style>


// WEBPACK FOOTER //
// src/modules/common/components/checkin/Checkin.vue